module.exports = __webpack_public_path__ + "static/media/assetCreation.cb35787d.jpg";